import { render } from "./ReactionsWrapper.vue?vue&type=template&id=14bb3ea4&scoped=true"
import script from "./ReactionsWrapper.vue?vue&type=script&lang=js"
export * from "./ReactionsWrapper.vue?vue&type=script&lang=js"

import "./ReactionsWrapper.vue?vue&type=style&index=0&id=14bb3ea4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14bb3ea4"]])

export default __exports__